
export default function SuccessNumbersSection() {
  const stats = [
    {
      number: "2,500+",
      label: "Learners Trained",
      icon: "ri-graduation-cap-line",
      description: "Across all programmes"
    },
    {
      number: "95%",
      label: "Completion Rate",
      icon: "ri-trophy-line",
      description: "Industry-leading success"
    },
    {
      number: "150+",
      label: "Corporate Clients",
      icon: "ri-building-line",
      description: "Trusted partnerships"
    },
    {
      number: "85%",
      label: "Client Retention",
      icon: "ri-heart-line",
      description: "Long-term relationships"
    },
    {
      number: "R45M+",
      label: "SETA Funding Secured",
      icon: "ri-money-dollar-circle-line",
      description: "For our clients"
    },
    {
      number: "12",
      label: "Years Experience",
      icon: "ri-time-line",
      description: "Industry expertise"
    },
    {
      number: "98%",
      label: "Satisfaction Rate",
      icon: "ri-thumb-up-line",
      description: "Client feedback"
    },
    {
      number: "25+",
      label: "QCTO Programmes",
      icon: "ri-award-line",
      description: "Accredited offerings"
    }
  ];

  return (
    <section className="section-wrap bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            Success by the Numbers
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our track record speaks for itself. Here are the measurable results we've achieved for our clients.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group">
              <div className="bg-[#F5F5F5] rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4 group-hover:bg-[#2D7F3E] transition-colors duration-300">
                <i className={`${stat.icon} text-3xl text-[#2D7F3E] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-bold text-[#2D7F3E] mb-2">
                {stat.number}
              </div>
              <div className="text-lg font-semibold text-[#1A1A1A] mb-1">
                {stat.label}
              </div>
              <div className="text-sm text-gray-600">
                {stat.description}
              </div>
            </div>
          ))}
        </div>

        {/* Additional Visual Element */}
        <div className="mt-16 bg-gradient-to-r from-[#2D7F3E] to-[#245A2E] rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Join Over 150 Companies That Trust Sylman Academy
          </h3>
          <p className="text-lg text-green-100 mb-6">
            From small businesses to large corporations, we've helped organisations across South Africa achieve their skills development goals.
          </p>
          <div className="flex flex-wrap justify-center gap-8 text-sm">
            <div className="flex items-center">
              <i className="ri-check-line text-green-300 mr-2"></i>
              QCTO Accredited
            </div>
            <div className="flex items-center">
              <i className="ri-check-line text-green-300 mr-2"></i>
              SETA Approved
            </div>
            <div className="flex items-center">
              <i className="ri-check-line text-green-300 mr-2"></i>
              B-BBEE Compliant
            </div>
            <div className="flex items-center">
              <i className="ri-check-line text-green-300 mr-2"></i>
              ISO 9001 Certified
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
